import { StubHubRoutesEnum } from "models/enums/apiRoutes/stubHubApiRoutes";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";
export class CompetitorPricesService {
  public getCompetitorPrices = async (competitorPricesDto: {
    event_id: number;
    venue_id: number;
    site_type: string;
    seatmap_url: string;
    force_refresh: boolean;
  }) => {
    return axiosClient.get<IApiBaseResponse>(StubHubRoutesEnum.COMPETITOR_PRICES, {
        params: competitorPricesDto
    });
  };

  public getSecondaryMarketplaceMaster = async () => {
    return axiosClient.get<IApiBaseResponse>(
      StubHubRoutesEnum.SECONDARY_MARKETPLACE_MASTER
    );
  };
}